// extracted by mini-css-extract-plugin
export default {"wrapper":"HB-z","viewport":"IB-z","container":"JB-z","slide":"KB-z"};